import { useAuth } from '@/contexts/AuthContext';
import { useScrollLock } from '@/hooks/useScrollLock';

/**
 * ログアウト時に画面全体をフェードで覆うオーバーレイ。
 * オーバーレイが画面を覆ってから状態クリアとログイン画面への遷移が行われるため、
 * ダッシュボードからログイン画面への切り替えがなめらかになる。
 * アニメーション終了時に自動でアンマウントする。
 */
export default function LogoutOverlay() {
  const { loggingOut, endLogout } = useAuth();
  // オーバーレイ表示中は背景（ページ本体）のスクロールを固定する。
  useScrollLock(loggingOut);

  if (!loggingOut) {
    return null;
  }

  return (
    <div
      className="logout-overlay fixed inset-0 z-[200]"
      onAnimationEnd={endLogout}
      aria-hidden="true"
    />
  );
}